import React, { useState, useEffect, createContext, useContext } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";
import BookingModal from "./components/BookingModal";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import PlansPage from "./pages/PlansPage";
import BlogPage from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/ScrollToTop";

// Booking modal context so any CTA can open the booking flow
const BookingContext = createContext();
export const useBooking = () => useContext(BookingContext);

function App() {
  const [open, setOpen] = useState(false);
  const openBooking = () => setOpen(true);
  const closeBooking = () => setOpen(false);

  return (
    <div className="App">
      <BookingContext.Provider value={{ openBooking, closeBooking }}>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/plans" element={<PlansPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
          <FloatingActions />
          <BookingModal open={open} onClose={closeBooking} />
        </BrowserRouter>
        <Toaster />
      </BookingContext.Provider>
    </div>
  );
}

export default App;
